export default class ExclusionModal {
  constructor(component) {
    this.dom = {
      $component: component,
      $body: document.querySelector('body'),
      $modalToggles: document.querySelectorAll('.js-exclusionModalToggle, a[href="/exclusion-modal"]'),
      $modal: document.querySelector('.js-exclusionModal'),
      $modalUnderlay: document.querySelector('.js-exclusionModalUnderlay'),
    }
    this.state = {
      modalOpen: false,
      modalOpenClass: 'openModal',
      modalUnderlayActiveClass: 'isActive',
      bodyFixedClass: 'bodyFixed',
    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this

    dom.$modalToggles.forEach(($toggle) => $toggle.addEventListener('click', this.modalCheck.bind(this)))
  }

  modalCheck(e) {
    const { dom, state } = this

    e.preventDefault()
    if (state.modalOpen) {
      dom.$modal.setAttribute('aria-hidden', 'true')
      dom.$modal.setAttribute('aria-expanded', 'false')
      dom.$modal.classList.remove(state.modalOpenClass)
      dom.$modalUnderlay.classList.remove(state.modalUnderlayActiveClass)
      dom.$body.classList.remove(state.bodyFixedClass)
      state.modalOpen = false
    } else {
      dom.$modal.setAttribute('aria-hidden', 'false')
      dom.$modal.setAttribute('aria-expanded', 'true')
      dom.$modal.classList.add(state.modalOpenClass)
      dom.$modalUnderlay.classList.add(state.modalUnderlayActiveClass)
      if (window.innerWidth <= 1024) {
        dom.$body.classList.add(state.bodyFixedClass)
      }
      state.modalOpen = true
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ExclusionModal = this
  }
}
